import { createSelector } from 'selectors'

import { form } from './constant'

const getLanguageSelect = () => createSelector<HTMLSelectElement>({ selector: form.selector.languageSelect })

const getHtmlTextArea = () => createSelector<HTMLInputElement>({ selector: form.selector.htmlTextArea })

export const getFormComponents = () => ({
	languageSelect: getLanguageSelect(),
	htmlTextArea: getHtmlTextArea(),
})
